<template>
  <div class="ppcPopup board-page" >

    <Menu />
    <div>
      <PPCHeader :board="board"  :brand="brand" />

    </div>
    <div class="ppcPopupItemContainer" :key="refreshKey">
      <PPCThumbnail  :board="board" :accountView="accountView"/>
      <PPCCenter :accountView="accountView" :creative="selectedCreative" :board="board"/>
      <PPCCommentSection  :creative="selectedCreative" :board="board" :brand="board.campaign.brand" v-if="board.campaign && openCommentSection" :accountView="accountView" />
    </div>
  </div>
</template>

<script>
import PPCCommentSection from '@/components/PPCCommentSection';
import PPCThumbnail from '@/components/PPCThumbnail';
import PPCCenter from '@/components/PPCCenter';
import PPCHeader from '@/components/PPCHeader';
import Menu from '@/components/Menu';
import {mapState} from 'vuex';
import viewMI from '@/mixins/viewMI.js'
export default {
    data(){
        return {
          refreshKey:0,
            board: false,
          brand: [],
            steps: [],
            selectedCreativeIdx: -1,
            accountView: false,
            statusorder: {
        draft: 1,
        live: 2,
        done: 3,
        rejected: 4
      }
        }
    },
    mixins: [viewMI],
    components:{

        PPCThumbnail,
        PPCCenter,
        PPCCommentSection,
        PPCHeader,
        Menu
    },
    watch:{
      selectedCreativeIdx(){
        this.seenCreative();
      }
    },
    created(){
       
    },
    computed: {
     ...mapState(['openCommentSection']),
     selectedCreative(){
       if (this.board.creative)
       {
        return this.board.creative[this.selectedCreativeIdx]
       }

      return false;
     }
   },
   methods:{
     
     keyPressed(){
       //console.log('right');
     },
     selectCreativeByParentId(parent_id){
       this.$store.state.drawingMode=false;
       this.$store.state.drawViewMode=false;
       this.$store.state.locationViewMode=false;
        this.$store.state.view_comment=false;
       //console.log('parent_id',parent_id);
       for (var i = 0; i< this.board.creative.length; i++){
         if (this.board.creative[i].parent_id == parent_id){
           this.selectedCreativeIdx = i;
           this.$forceUpdate();
         }
       }
     },
     async selectCreativeById(id){
      console.log('selectByid:'+ id)
      var _this = this;
      return new Promise(resolve => {
       _this.$store.state.locationViewMode=false;
        _this.$store.state.view_comment=false;
        _this.$store.state.drawingMode=false;
        _this.$store.state.drawViewMode=false;
       for (var i = 0; i< _this.board.creative.filter(c=>c.parent_id == 0).length; i++){
        
         if (_this.board.creative[i].id == id){
           _this.selectedCreativeIdx = i;
           console.log('selectedByid:'+ i)
           _this.$forceUpdate();
           resolve();
         }
       }
       resolve();
      })
     },
     userReady: function(){
        if (this.$store.state.user.user_type == 'account' || this.$store.state.user.user_type == 'administrator' )
          this.accountView = true;

        this.refreshBoard(true);

      },
     refreshBrand(){
       // console.log('rb brand')
       var _this = this;
       //console.log('rB');
       this.get('brand',{params: {
           where: [
             ['where','slug',_this.$route.params.brand_slug]
           ],
           relations:1,
           relations_params:{
             user: {
               //where : (_this.$store.state.user.user_type == 'client') ? [['where','user_type','client']] : [['where','user_type !=','asdasdas']]
             },
             campaign: {
               relations:1,
               order_by:[['created_at','desc']],
               relations_params:{
                 board: {
                   relations: 1,
                   relations_params:{
                     creative: {
                       where: [['where','parent_id','0'],['where','internal',0]],
                       
                     }
                   }
                 }
               }
             }
           },

         }},function(resp){
         _this.brand = resp.data.brand[0];
         _this.refreshTimeline();
         _this.steps = [
           {'name':'Clients',path: "/dashboard"},
         ],
             _this.steps.push({
               name: _this.brand.client.name,path:'/client/'+_this.brand.client.slug
             })
         _this.steps.push({
           name: _this.brand.name,path:'#'
         })
         //console.log(_this.steps);
         _this.$forceUpdate();
       })
     },
      async refreshBoard(needReselect){

        if (needReselect == undefined)
          needReselect = false;
        var _this = this;
        return new Promise(resolve => {
        this.get('board',{params: {
          where: [
            ['where','slug',_this.$route.params.board_slug]
          ],
          relations: 1,
          relations_params:{
            creative: {
              relations: 1,
              where: [['where','internal',0]],
              relations_params:{
                board:{
                  relations: 1,
                  campaign:{
                    relations: 1
                  }
                },
                comment: {

                  relations_params:{
                    replies:{
                      relations:1
                    }

                  },
                  relations:1
                }
              }
            },

            campaign: {
              relations: 1,
              relations_params:{
                brand: {
                  relations: 1
                }
              }
            }
          }


        }},function(resp){
          _this.board = resp.data.board[0];
          if (_this.board.creative)
         {
           _this.board.creative.sort(function(a,b){
            if (a.status != a.status)
            {
              return _this.statusorder[a.status ]-_this.statusorder[b.status];
            }
            else
            {
              return b.id - a.id;
        }
      
           })
         }
          if (needReselect)
          {
            var selectidx = 0;
            if (_this.$route.params.creative_idx)
              selectidx = Math.min(_this.$route.params.creative_idx,_this.board.creative.filter(c=>parseInt(c.parent_id) == 0).length);
            var rootelement = 0;
            for (var i = 0; i< _this.board.creative.length; i++){
              if (_this.board.creative[i].parent_id == 0)
              {
                rootelement++;
                if (rootelement > selectidx)
                {
                  _this.selectedCreativeIdx = i;
                  console.log(!_this.accountView ,  _this.board.creative[_this.selectedCreativeIdx].status == 'draft' ,_this.board.creative[_this.selectedCreativeIdx].child )
                  if (!_this.accountView && _this.board.creative[_this.selectedCreativeIdx].status == 'draft' && _this.board.creative[_this.selectedCreativeIdx].child )
                  {
                   
                    _this.selectCreativeById(_this.board.creative[_this.selectedCreativeIdx].child.id)
                  }
                  
                  break;
                }
              }
            }
          }
          
          _this.steps = [
            {'name':'Clients',path: "/dashboard"},
          ],
          _this.steps.push({
            name: _this.board.campaign.brand.client.name,path:'/client/'+_this.board.campaign.brand.client.slug
          })
          _this.steps.push({
            name: _this.board.campaign.brand.name,path:'/brand/'+_this.board.campaign.brand.slug
          })
          _this.steps.push({
            name: _this.board.campaign.name,path:'#'
          })
          _this.steps.push({
            name: _this.board.name,path:'#'
          })
          _this.steps.push({
            name: _this.board.name,path:'/brand/'+_this.board.slug
          })
          console.log('SELECTED CREATIVE IDX:',_this.selectedCreativeIdx);
          _this.$forceUpdate();
          _this.refreshKey++;

          resolve();
        })
      });
      },
      seenCreative(){
        
        var _this = this;
        if (this.board.creative[this.selectedCreativeIdx].creative_seen)
        {
          if (this.board.creative[this.selectedCreativeIdx].creative_seen.filter(element=>{element.user_id == _this.$store.state.user.id}) > 0) 
            return;
        }
        this.post('creative_seen',{
          creative_id: this.board.creative[this.selectedCreativeIdx].id,
          payment_cluster_id : this.board.payment_cluster_id,
          user_id: this.$store.state.user.id
        },{},function(){
          _this.refreshBoard()
        });
      }
    },


}
</script>

<style scoped>
.ppcPopup {
  display: flex;
  flex-direction: column;
}

.ppcPopupItemContainer {
  display: flex;
  flex-direction: row;
  height: 100vh;
  overflow: hidden;
}
</style>